import { ProdutoPromocional } from '../models/produtos/produto-promocional';

/** Fator unitario contido no preco final, sem modificar os campos que formam o preco. */
export function fatorFinanceiroItem(produto: ProdutoPromocional, percentual: number, ativo: boolean): number | null {
  if (produto == null) return null;

  // Campanhas mantem a composicao financeira dos seus subitens.
  if (!ativo || produto.id_campanha != null || produto.produtos_vinculados?.length > 0) {
    return produto.valor_fator_financeiro_unitario ?? null;
  }
  if (produto.aplica_fator_financeiro !== true || produto.bonificacao || produto.qtde_lote > 0
      || produto.estado_preco?.temFator === false) return 0;

  const valor = Number(produto.valor);
  const fator = Number(percentual);
  const multiplicador = 1 + fator / 100;
  if (produto.valor == null || !Number.isFinite(valor) || !Number.isFinite(fator) || multiplicador <= 0) return null;

  const semFator = valor / multiplicador;
  return Number((valor - semFator).toFixed(4));
}
